import { QueryClient } from '@tanstack/react-query';

import { isApiError } from '@/api/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Retrying a 403 or a 404 wastes time and, worse, hides the real
        // message behind three seconds of spinner. Only transient failures
        // are worth another attempt.
        if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
